import { Spinner } from 'shared/Spinner';

export const Loader = () => (
    <div data-testid="Spinner" className="grid justify-center m-16">
        <Spinner size="xl" />
    </div>
);
